import isEmpty from '../../utility/isEmpty'

export default {
  processAddresses (state) {
    return function (addresses) {
      if (!isEmpty(addresses)) {
        addresses.reduce((acc, element) => { // Ensure the 'Home' address is the first in the list
          if (element.typeName === 'Home') { // TODO: Worry about this changing with localization changes (could pull from a lang file)
            return [element, ...acc]
          }

          return [...acc, element]
        }, [])

        for (let i = 0; i < addresses.length; i++) {
          addresses[i].display = true
          addresses[i].sameAddresses = false
          addresses[i].index = i
        }
      }

      return addresses
    }
  },

  hasCustomerId (state) {
    return !isEmpty(state.customerIds)
  },

  /**
   * Returns the TLXe Customer ID if one is available.
   * @param {Object} state - The current Vuex customer state values.
   */
  tlxeCustomerId (state) {
    return !isEmpty(state.customerIds) && !isEmpty(state.lmsReferenceIds) && !isEmpty(state.lmsReferenceIds.TLXe) && !isEmpty(state.customerIds[state.lmsReferenceIds.TLXe]) ? state.customerIds[state.lmsReferenceIds.TLXe] : undefined
  },

  /**
   * Checks to see if the user only has a TLXe customer ID. If no Customer IDs exist or no LMS Reference IDs exist, false is returned.
   * @param {Object} state - The current Vuex customer state values.
   * @param {Object} getters - The current Vuex store's getters.
   */
  isTlxeUser (state, getters) {
    return !isEmpty(getters.tlxeCustomerId)
  },

  /**
   * Validate the stored names with the passed in name.
   *
   * Normalizing and doing indexOf and character checks allows us to handle:
   * 1) multi-name first and last names
   * 2) customers who's middle name is on the card
   * 3) customers who have suffixes (Jr, Sr, III, etc.) on their card
   * 4) more 'traditional' first/last name combos
   * NOTE:  this.firstName and this.lastName come from the server and are never change
   * @param {Object} state - The current Vuex customer state values.
   * @returns {firstNameMatches: Boolean, lastNameMatches: Boolean} Whether the first and last name match the passed in name.
   */
  validateName (state) {
    return (name) => {
      const enteredName = name.toLowerCase() // normalize
      const indexOfFirstName = enteredName.indexOf(state.customerFirstName.toLowerCase())
      const nextIndexFirstName = indexOfFirstName + state.customerFirstName.length

      const indexOfLastName = enteredName.lastIndexOf(state.customerLastName.toLowerCase())
      const nextIndexLastName = indexOfLastName + state.customerLastName.length

      const firstNameMatches = (indexOfFirstName > -1) && (indexOfFirstName < indexOfLastName) && enteredName[nextIndexFirstName] === ' '
      const lastNameMatches = (indexOfLastName > -1) && (indexOfFirstName < indexOfLastName) && (enteredName[nextIndexLastName] === ' ' || isEmpty(enteredName[nextIndexLastName]))

      return {
        firstNameMatches,
        lastNameMatches
      }
    }
  },

  isNonCustomer (state) {
    return isEmpty(state.customerIds)
  },

  isNewProfile (state, getters, rootState) {
    return isEmpty(state.customerIds) && !rootState.referral.ncrCognitoAttribute
  },

  customerEmail (state, getters, rootState) {
    return !isEmpty(state.email) ? state.email : rootState.session.email
  },

  /**
   * Gets the primary bank account or the first bank in the list, if no primary.
   * @returns {{id: Number, accountNumber: String, bankName: String, routingNumber: String, primary: Boolean}}
   */
  activeBank (state) {
    if (isEmpty(state.banks)) {
      return undefined
    }

    return state.banks.find(bank => bank.primary) || state.banks[0]
  },

  activeBankInfo (state, getters) {
    if (isEmpty(getters.activeBank)) {
      return ''
    }

    if (!isEmpty(getters.activeBank.bankName) && !isEmpty(getters.activeBank.accountNumber)) {
      return `${getters.activeBank.bankName} ****${getters.activeBank.accountNumber}`
    }

    if (!isEmpty(getters.activeBank.accountNumber)) {
      return `****${getters.activeBank.accountNumber}`
    }

    return ''
  }
}
